import {Box, BoxProps, HStack, Text, VStack} from '@chakra-ui/layout';
import {EtatMatching} from 'api-types/ffconnect';
import {useTranslation} from 'react-i18next';

// Wrapper standard pour les sections de matching
export const MatchSection: React.FC<{
  children: React.ReactNode;
}> = ({children}) => {
  return (
    <VStack
      alignItems='stretch'
      spacing={3}
      bg='white'
      p={4}
      borderRadius='md'
      borderWidth='1px'
      borderColor='gray.light'
    >
      {children}
    </VStack>
  );
};

// En-tête standard pour les sections de matching avec titre et badge de statut optionnel
export const MatchSectionHeader: React.FC<{
  title: string;
  etat?: EtatMatching;
  leftElement?: React.ReactNode;
}> = ({title, etat, leftElement}) => {
  return (
    <HStack
      justifyContent='space-between'
      alignItems='center'
    >
      <Text
        fontSize='sm'
        fontWeight='bold'
        color='gray.dark'
        flex={1}
      >
        {title}
      </Text>
      {leftElement}
      {etat && <MatchingSectionEtatBadge etat={etat} />}
    </HStack>
  );
};

// Badge d'état pour les sections matching
export const MatchingSectionEtatBadge: React.FC<
  {etat: EtatMatching} & BoxProps
> = ({etat, ...props}) => {
  const {t} = useTranslation();
  const config = {
    ok: {
      bg: 'green.success_bg',
      color: 'green.success',
      label: 'etat_badge_ok',
    },
    alerte: {
      bg: 'yellow.warning',
      color: 'yellow.warning_text',
      label: 'etat_badge_alerte',
    },
    bloquant: {
      bg: 'red.warning_bg',
      color: 'red.fail',
      label: 'etat_badge_bloquant',
    },
  }[etat];

  return (
    <Box
      px={2}
      py={1}
      borderRadius='md'
      fontSize='xs'
      fontWeight='bold'
      bg={config.bg}
      color={config.color}
      textAlign='center'
      {...props}
    >
      {t(`back_office.pdf_order_import.match.${config.label}`)}
    </Box>
  );
};

// Badge pour les critères (critere_utilise, critere_match)
export const CritereBadge: React.FC<{
  critere: string;
}> = ({critere}) => {
  const {t} = useTranslation();
  return (
    <Box
      px={1.5}
      py={0.5}
      borderRadius='sm'
      fontSize='xx-small'
      fontWeight='medium'
      bg='blue.200'
      color='blue.700'
    >
      {t(critere)}
    </Box>
  );
};
